import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';
import { DASHBOARD_RESOURCES } from 'constant';

import ListPaymentPGFailure from './submodules/list';
import UpdatePaymentPGFailure from './submodules/edit';
import { FINANCE_RESOURCES, URL } from '../helper';

const PaymentPGFailureDashboard: React.FC<{}> = () => {
	return (
		<Switch>
			<AuthorizedRoute
				exact
				configPageName={DASHBOARD_RESOURCES.finance}
				configResourceName={FINANCE_RESOURCES.paymentPgFailure}
				configActionName='getPaymentPGFailureList'
				path={`${URL[FINANCE_RESOURCES.paymentPgFailure]}/list`}
				component={ListPaymentPGFailure}
			/>
			<AuthorizedRoute
				exact
				configPageName={DASHBOARD_RESOURCES.finance}
				configResourceName={FINANCE_RESOURCES.paymentPgFailure}
				configActionName='updatePaymentPGFailureData'
				path={`${URL[FINANCE_RESOURCES.paymentPgFailure]}/edit`}
				component={UpdatePaymentPGFailure}
			/>
			<Redirect to={`${URL[FINANCE_RESOURCES.paymentPgFailure]}/list`} />
		</Switch>
	);
};

export default PaymentPGFailureDashboard;
